import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './UI/App';
import * as serviceWorker from './serviceWorker';
import './assets/fonts/exo/Exo2.0-Light.otf';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

serviceWorker.unregister();
